<template>
    <div id="agency-modal">
        <div class="container">
            <div class="body-modal modal-agency">
                <div>
                    <div class="content">
                        <div>
                            <div>
                                <span class="title mobile">{{ data.title }}</span>
                            </div>
                            <div>
                                <img :src="require('@/assets/img/' + data.img)" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <span class="title desktop">{{ data.title }}</span>
                                <div v-html="data.desc" class="desc"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AgencyModal",
    data() {
        return {
            local: "fr",
            data: null,
            items: [],
        };
    },
    computed: {
        modal: function () {
            return this.$store.state.app.modal;
        },
    },
    watch: {
        "$i18n.locale": function (locale) {
            this.local = locale;
        },
    },
    beforeMount() {
        this.data = this.$store.state.app.modal.content;
    },
    mounted() {
        let lkContact = document.querySelector(".lk-contact");
        if (lkContact) {
            lkContact.addEventListener("click", (e) => {
                e.preventDefault();

                const el = document.getElementById("contact");
                if (el) {
                    const y = el.getBoundingClientRect().top + window.scrollY;
                    window.scrollTo({ top: y, behavior: "smooth" });
                }

                this.$store.dispatch("app/displayModal", {
                    display: false,
                });
            });
        }
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
#agency-modal {
    background: url("@/assets/img/bg_modal_harkhan.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    width: 100%;
    min-height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .modal-agency {
        padding: 6rem 0;
        box-sizing: border-box;

        > div {
            max-width: 1400px;
            margin: auto;
        }

        .content {
            display: flex;
            flex-flow: row nowrap;

            > div {
                &:first-child {
                    width: 50%;
                    flex: 0 0 50%;
                    padding-right: 2rem;
                    box-sizing: border-box;

                    img {
                        border-radius: 15px;
                        overflow: hidden;
                        width: 100%;
                        border: 0;
                    }
                }

                &:last-child {
                    width: 50%;
                    flex: 0 0 50%;
                    display: flex;
                    flex-flow: column;
                }
            }
        }

        .title {
            font-family: Oswald, sans-serif;
            color: #0c143a;
            font-size: 2.2rem;
            padding: 0;
            font-weight: 700;

            &.mobile {
                display: none;
            }
        }

        .desc {
            color: #0c143a;
            padding: 0;
            font-size: 1.2rem;
            font-weight: 300;
        }
    }
}

@media (max-width: 1400px) {
    #agency-modal .modal-agency {
        .content {
            > div {
                &:first-child {
                    width: 60%;
                    flex: 0 0 60%;
                    padding-right: 2rem;
                }

                &:last-child {
                    width: 40%;
                    flex: 0 0 40%;

                    > div:last-child {
                        margin-bottom: 2rem;
                    }
                }
            }
        }

        .title {
            font-size: 2rem;
        }

        .desc {
            font-size: 1.2rem;
        }
    }
}
@media (max-width: 1200px) {
    #agency-modal .modal-agency {
        .content {
            > div {
                &:first-child {
                    width: 60%;
                    flex: 0 0 60%;
                    padding-right: 2rem;
                }

                &:last-child {
                    width: 40%;
                    flex: 0 0 40%;

                    > div:last-child {
                        margin-bottom: 2rem;
                    }
                }
            }
        }

        .title {
            font-size: 1.8rem;
        }

        .desc {
            font-size: 1.1rem;
        }
    }
}

@media (max-width: 992px) {
    #agency-modal .modal-agency {
        .content {
            flex-flow: column;

            > div {
                &:first-child {
                    width: 100%;
                    flex: 0 0 100%;
                    padding-right: 0;
                }

                &:last-child {
                    width: 100%;
                    flex: 0 0 100%;

                    > div:last-child {
                        margin-bottom: 2rem;
                    }
                }
            }
        }

        .title {
            font-size: 1.8rem;

            &.desktop {
                display: none;
            }

            &.mobile {
                display: block;
                margin-bottom: 0.7rem;
            }
        }

        .desc {
            font-size: 1.1rem;
        }
    }
}

@media (max-width: 768px) {
    #agency-modal .modal-agency {
        padding: 4rem 0;
    }
}
</style>
